import { Icon } from 'gu-ui-kit'
import React from 'react'
import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'

const now = new Date()
const startDate = subWeeks(now, 2)

export default (listMode) => {
  const common = {
    initial: {
      search: '',
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(now, 'yyyy-MM-dd'),
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'wallets::filters.input.placeholder',
        placeholder: 'wallets::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      datepicker: {
        names: ['date_from', 'date_to'],
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.sm,
        },
        // @todo нужен общий лейбл а не в пульсе
        label: 'pulse::filters.range.label',
        order: 2,
        type: 'datepicker',
      },
    },
  }

  switch (listMode) {
    case 'transactions':
      return {
        initial: {
          ...common.initial,
          types: [],
        },
        configuration: {
          ...common.configuration,
          types: {
            subbutton: {
              isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
            },
            icon: (
              <Icon
                name={'avatar1'}
                size={'s'}
                bgColor={'Accent-Confirm-Secondary'}
                color={'Label-Onsurface'}
              />
            ),
            label: 'wallets::filters.dropdown.items.types.label',
            position: 'dropdown',
            type: 'checkbox group',
            optionLabelPrefix: 'wallets::filters.dropdown.items.types.options.',
            options: ['payment', 'partner_payment', 'award', 'transfer'],
          },
        },
      }

    default:
      return {
        initial: {
          ...common.initial,
          statuses: [],
        },
        configuration: {
          ...common.configuration,
          statuses: {
            subbutton: {
              isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
            },
            icon: (
              <Icon
                name={'avatar1'}
                size={'s'}
                bgColor={'Accent-Confirm-Secondary'}
                color={'Label-Onsurface'}
              />
            ),
            label: 'services::account_list.status_label',
            position: 'dropdown',
            type: 'checkbox group',
            optionLabelPrefix: 'services::transfers_list.status.',
            options: ['pending', 'paused', 'success', 'cancelled', 'declined'],
          },
        },
      }
  }
}
